/* global grecaptcha */
// const { config } = require("../utils/constants");

/**
 * reCAPTCHA v3 Module
 * Handles loading and executing Google reCAPTCHA v3
 */
const RecaptchaV3 = (function () {
  let siteKey ="6LfPd24sAAAAANSf_pKhBDYURI2VDqzaecK5Uyvj";
  let isLoaded = false;
  let isLoading = false;
  let currentToken = null;

  /**
   * Load the reCAPTCHA v3 script dynamically
   * @returns {Promise} Resolves when script is loaded
   */
  function loadScript() {
    return new Promise(function (resolve, reject) {
      if (!siteKey) {
        resolve(false);
        return;
      }

      if (isLoaded) {
        resolve(true);
        return;
      }

      if (isLoading) {
        // Wait for existing load to complete
        var checkInterval = setInterval(function () {
          if (isLoaded) {
            clearInterval(checkInterval);
            resolve(true);
          }
        }, 100);
        return;
      }

      isLoading = true;

      var script = document.createElement("script");
      script.src = "https://www.google.com/recaptcha/api.js?render=" + siteKey;
      script.async = true;
      script.defer = true;

      script.onload = function () {
        isLoaded = true;
        isLoading = false;
        resolve(true);
      };

      script.onerror = function () {
        isLoading = false;
        reject(new Error("Failed to load reCAPTCHA script"));
      };

      document.head.appendChild(script);
    });
  }

  /**
   * Execute reCAPTCHA v3 and get a token
   * @param {string} action - The action name for this request (e.g., 'login', 'submit')
   * @returns {Promise<string|null>} Resolves with token or null if not configured
   */
  function execute(action) {
    return new Promise(function (resolve, reject) {
      if (!siteKey) {
        resolve(null);
        return;
      }

      // Ensure script is loaded first
      loadScript()
        .then(function () {
          if (typeof grecaptcha === "undefined" || !grecaptcha.execute) {
            // Wait for grecaptcha to be ready
            waitForGrecaptcha(action, resolve, reject);
          } else {
            executeRecaptcha(action, resolve, reject);
          }
        })
        .catch(reject);
    });
  }

  /**
   * Wait for grecaptcha to be available
   */
  function waitForGrecaptcha(action, resolve, reject, attempts) {
    attempts = attempts || 0;
    var maxAttempts = 20; // 10 seconds max wait

    if (attempts >= maxAttempts) {
      reject(new Error("reCAPTCHA failed to initialize"));
      return;
    }

    if (typeof grecaptcha !== "undefined" && grecaptcha.execute) {
      executeRecaptcha(action, resolve, reject);
    } else {
      setTimeout(function () {
        waitForGrecaptcha(action, resolve, reject, attempts + 1);
      }, 500);
    }
  }

  /**
   * Execute the reCAPTCHA
   */
  function executeRecaptcha(action, resolve, reject) {
    grecaptcha.ready(function () {
      grecaptcha
        .execute(siteKey, { action: action || "submit" })
        .then(function (token) {
          currentToken = token;
          resolve(token);
        })
        .catch(function (err) {
          console.error("reCAPTCHA execution error:", err);
          currentToken = null;
          reject(err);
        });
    });
  }

  /**
   * Reset the current token (call this on error to prepare for retry)
   * Note: v3 doesn't have a visible widget to reset, 
   * just clears the stored token. Next execute() call will get a fresh token.
   */
  function reset() {
    currentToken = null;
  }

  /**
   * Get the current token (if any)
   * @returns {string|null}
   */
  function getToken() {
    return currentToken;
  }

  /**
   * Check if reCAPTCHA is configured
   * @returns {boolean}
   */
  function isConfigured() {
    return !!siteKey;
  }

  /**
   * Get the site key
   * @returns {string}
   */
  function getSiteKey() {
    return siteKey;
  }

  /**
   * Initialize with a custom site key (optional)
   * @param {string} key - The reCAPTCHA site key
   */
  function init(key) {
    if (key) {
      siteKey = key;
    }
    // Pre-load the script
    loadScript();
  }

  // Public API
  return {
    init: init,
    loadScript: loadScript,
    execute: execute,
    reset: reset,
    getToken: getToken,
    isConfigured: isConfigured,
    getSiteKey: getSiteKey,
  };
})();

module.exports = RecaptchaV3;